import { observer } from "mobx-react-lite";
import { useTran } from "@/hooks";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { cn } from "@/lib/utils";
import { EMPLOYEE_RANGE, ANNUAL_REVENUE } from "@/lib/constants";
import { useCompanyStore } from "../hooks";

const ChoiceGrid = ({ id, label, options, value, onChange, error }) => (
  <div className="space-y-2">
    <Label className="block font-medium text-foreground">
      {label}
      <span className="text-destructive ml-1">*</span>
    </Label>
    <RadioGroup
      value={value}
      onValueChange={onChange}
      className="grid gap-3 sm:grid-cols-2"
    >
      {(options || []).map((option) => (
        <label
          key={`${id}-${option}`}
          className={cn(
            "flex items-center gap-3 rounded-radius border px-3 py-3 text-sm transition",
            value === option
              ? "border-primary bg-primary/10"
              : "border-border hover:bg-muted/50",
          )}
        >
          <RadioGroupItem value={option} id={`${id}-${option}`} />
          <span className="font-medium text-foreground">{option}</span>
        </label>
      ))}
    </RadioGroup>
    {error ? <p className="text-sm text-destructive">{error}</p> : null}
  </div>
);

const CompanySetupStepThree = observer(({ getFieldError, handleBlur }) => {
  const { t } = useTran();
  const { form, setField } = useCompanyStore();

  const handleEmployeesChange = (value) => {
    setField("employeesRange", value);
    handleBlur("employeesRange")();
  };

  const handleRevenueChange = (value) => {
    setField("revenueRange", value);
    handleBlur("revenueRange")();
  };

  return (
    <div className="space-y-6">
      <ChoiceGrid
        id="employeesRange"
        label={t("How many employees do you have?")}
        options={EMPLOYEE_RANGE}
        value={form.employeesRange}
        onChange={handleEmployeesChange}
        error={getFieldError("employeesRange")}
      />
      <ChoiceGrid
        id="revenueRange"
        label={t("What is your annual revenue in USD?")}
        options={ANNUAL_REVENUE}
        value={form.revenueRange}
        onChange={handleRevenueChange}
        error={getFieldError("revenueRange")}
      />
    </div>
  );
});

export default CompanySetupStepThree;
